import HttpFactory from '../factory'
import type { PatientInformation } from '../types/patient/information'
import type { LivingPlace } from '../types/patient/livingPlace'
import type { Patient, PatientNhiVersion } from '../types/patient/patient'

class PatientsModule extends HttpFactory<any[]> {
  private PATH = '/patients'

  async get(id: string): Promise<Patient | Patient[]> {
    if (id) {
      return await this.call<any>('GET', `${this.PATH}/${id}`)
    } else {
      return await this.call<any>('GET', `${this.PATH}`).then((reponse) => reponse.items)
    }
  }

  async post(data: any): Promise<Patient> {
    return await this.call<any>('POST', `${this.PATH}`, data)
  }

  async patch(id: string, params: any, data: any): Promise<Patient> {
    return await this.call<any>('PATCH', `${this.PATH}/${id}`, data, { params })
  }

  async getInformation(id: string): Promise<PatientInformation> {
    return await this.call<any>('GET', `${this.PATH}/${id}/information`)
  }

  async patchInformation(id: string, params: any, data: any): Promise<PatientInformation> {
    return await this.call<any>('PATCH', `${this.PATH}/${id}/information`, data, { params })
  }

  async getNHIHistory(id: string): Promise<PatientNhiVersion[]> {
    return await this.call<any>('GET', `${this.PATH}/${id}/nhi/history`)
  }

  async postRefreshNhi(id: string): Promise<Patient> {
    return await this.call<any>('POST', `${this.PATH}/${id}/nhi/refreshes`, undefined)
  }
  async postVerifyNhi(id: string): Promise<Patient> {
    return await this.call<any>('POST', `${this.PATH}/${id}/nhi/verifications`, undefined)
  }
}

export default PatientsModule
